import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    '&.ant-tooltip .ant-tooltip-arrow::before': {
        backgroundColor: theme.colors.white,
    },

    '&.ant-tooltip .ant-tooltip-container': {
        color: theme.colors.brownGrey,
        backgroundColor: theme.colors.white,
    },
});
